/*
 * Controller for TrackerBase Main Page Footer
 * Angular.module: trackerbase-app.views.main-page.tb-main-page-footer
 * Controller name: tbMainPageFooterCtrl
 *
 */

import ngSanitizeModule from "angular-sanitize";
import uiRouterModule from "@uirouter/angularjs";

import Assert from "tbAssert";

import TbAppConfigDataServiceModule from "../../../config/tb-app-config/TbAppConfigDataService";
import CurrentVersionComponentModule from "../../../directives/CurrentVersion";
import TrackingCalendarViewConstants from "tbClient/views/tracking-calendar-view/Constants";
import GlobalViewUiComponentModule from "tbClient/directives/GlobalViewUi";

const mRootScopeSvc = new WeakMap();
const mUiRouterStateSvc = new WeakMap();

const mShowTbVersionNumber = new WeakMap();
const mShowTbVersionLabel = new WeakMap();
const mCalendarViewActive = new WeakMap();
const mCalendarFilterActive = new WeakMap();


class MainPageFooterController {
    constructor(TbAppConfigDataService, $rootScope, $state) {

        Assert.StrictAssert(TbAppConfigDataService != null,
            "Assertion Failure: Missing TrackerBase Application Configuration Data Service Dependency");
        Assert.StrictAssert($rootScope != null,
            "Assertion Failure: Missing Root Scope Service Dependency");
        Assert.StrictAssert($state != null,
            "Assertion Failure: Missing Ui Router State Service Dependency");

        mRootScopeSvc.set(this, $rootScope);
        mUiRouterStateSvc.set(this, $state);

        mShowTbVersionNumber.set(this, true);
        mShowTbVersionLabel.set(this, TbAppConfigDataService.tbShowVersionLabel);
        mCalendarViewActive.set(this, false);
        mCalendarFilterActive.set(this, false);
    }

    $onInit() {
        const rootScopeSvc = mRootScopeSvc.get(this);
        rootScopeSvc.$on("tb-calendar-filter-applied", (event, {filterIsActive}) => {
            mCalendarFilterActive.set(this, (filterIsActive === true));
        });

        this._updateIsCalendarViewActiveFlag();
        rootScopeSvc.$on("$stateChangeSuccess", (/* evt, toState, toParams, fromState, fromParams */) => {
            this._updateIsCalendarViewActiveFlag();
        });
    }

    get showFilterActive() {
        return (mCalendarFilterActive.get(this) && mCalendarViewActive.get(this));
    }

    get showTbVersionNumber() {
        return mShowTbVersionNumber.get(this);
    }

    set showTbVersionNumber(updatedVal) {
        mShowTbVersionNumber.set(this, updatedVal);
    }

    get showTbVersionLabel() {
        return mShowTbVersionLabel.get(this);
    }

    set showTbVersionLabel(updatedVal) {
        return mShowTbVersionLabel.set(this, updatedVal);
    }

    _updateIsCalendarViewActiveFlag() {
        if (mUiRouterStateSvc.get(this).is(TrackingCalendarViewConstants.rootStateName)) {
            mCalendarViewActive.set(this, true);
        }
        else {
            mCalendarViewActive.set(this, false);
        }
    }
}

MainPageFooterController.$inject = [
    "TbAppConfigDataService",
    "$rootScope",
    "$state"
];

MainPageFooterController.controllerAs = "tbMainFooterCtrl";

MainPageFooterController.dependencies = [
    ngSanitizeModule,
    uiRouterModule,
    CurrentVersionComponentModule,
    TbAppConfigDataServiceModule,
    GlobalViewUiComponentModule
];

MainPageFooterController.template = require("./MainPageFooter.tpl.html");

export default MainPageFooterController;




//////////////////
// WEBPACK FOOTER
// ./src/views/main-page/MainPageFooter/MainPageFooterController.js
// module id = JDzK
// module chunks = 1